'use client'
import { useCallback } from 'react'
import { Grid } from '@achieve/ascend'
import HeaderCta from './HeaderCta'
import { SignInLink } from 'components/SignInLink'
import { SIGN_IN_ROUTE } from 'constants/navigation'
import { FdrPage } from 'utils/environmentConfig'
import { useClientDashboardLoginOverlayTrigger } from '../../hooks/useClientDashboardLoginOverlayTrigger/useClientDashboardLoginOverlayTrigger.js'
import { useAnalyticsTrackEvent } from 'hooks/useAnalyticsTrackEvent'
import styles from './Header.module.scss'

export default function HeaderMobileActions({
  siteEnv = 'achieve',
  disabledRoutes = [],
  headerCta = true,
  signInLinkText,
  signInLinkUrl,
  getStartedLinkText,
  getStartedLinkUrl,
}) {
  const { openOverlayInsteadOfNavigating } = useClientDashboardLoginOverlayTrigger()
  const { analyticsTrackEvent } = useAnalyticsTrackEvent()
  const isFdr = siteEnv === FdrPage

  const handleButtonClick = useCallback(
    (href, name, isLeadCta) => {
      analyticsTrackEvent({
        nav_link_section: 'Header',
        click_type: 'Button Click',
        click_id: name,
        click_url: href,
        click_text: `FDR-Web | ${name}`,
        track_event: 'global_header',
        event_type: isLeadCta ? 'conversion' : 'track',
      })
    },
    [analyticsTrackEvent]
  )

  return (
    <Grid container className={styles['mobile-header-actions']} justifyContent="center">
      {!disabledRoutes.includes(SIGN_IN_ROUTE) && (
        <Grid
          size={{ xs: headerCta ? 6 : 12 }}
          alignItems="center"
          justifyContent="center"
          className={styles['mobile-header-actions-sign-in-link-container']}
        >
          <Grid item alignItems="center" justifyContent="center">
            <SignInLink
              siteEnv={siteEnv}
              disabledRoutes={disabledRoutes}
              data-testid="mobile-nav-sign-in-link"
              className={styles['mobile-header-actions-sign-in-link']}
              signInLinkText={signInLinkText}
              signInLinkUrl={signInLinkUrl}
              outlined={isFdr}
              onClick={
                isFdr
                  ? (e) => {
                      openOverlayInsteadOfNavigating(e)
                      handleButtonClick(signInLinkUrl, 'Sign In', false)
                    }
                  : undefined
              }
            />
          </Grid>
        </Grid>
      )}
      <Grid size={{ xs: 6 }}>
        {headerCta && (
          <HeaderCta
            siteEnv={siteEnv}
            className={styles['mobile-header-actions-cta']}
            size="small"
            data-testid="mobile-header-actions-get-started-button"
            linkUrl={getStartedLinkUrl}
            linkText={getStartedLinkText}
          />
        )}
      </Grid>
    </Grid>
  )
}
